import { inject, PLATFORM_ID } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { IPSAuthenticationService } from '@ips/common-angular';

export const authorizationGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const platformId = inject(PLATFORM_ID);
  const authService = inject(IPSAuthenticationService);
  const router = inject(Router);

  if (isPlatformBrowser(platformId)) {
    const currentUser = authService.currentUserValue;
    if (currentUser?.authenticated) {
      // authorised so return true
      return true;
    } else {
      // not logged in so redirect to login page with the return url
      router.navigate([''], { queryParams: { returnUrl: encodeURIComponent(state.url) } });
      return false;
    }
  }

  // If not running in the browser, allow the navigation
  return true;
};
